// frontend/src/components/PartyRepresentativesSection.jsx
import React from "react";
import PartyRepresentativeCard from "./PartyRepresentativeCard";

const mockRepresentatives = [
  {
    name: "Asha Kumari",
    image: "/image/asha-kumari.jpg",
    position: "MLA",
    party: "Indian National Congress",
    state: "Himachal Pradesh",
    constituency: "Dalhousie",
  },
  {
    name: "Ravi Verma",
    image: "/image/ravi-verma.jpg",
    position: "MP",
    party: "Bharatiya Janata Party",
    state: "Uttar Pradesh",
    constituency: "Lucknow",
  },
  {
    name: "Neha Patil",
    image: "/image/neha-patil.jpg",
    position: "Panchayat Member",
    party: "Independent",
    state: "Maharashtra",
    constituency: "Sangli",
  },
];

const PartyRepresentativesSection = () => {
  return (
    <section className="bg-gradient-to-b from-orange-50 via-white to-green-50 py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-10">
        <h2 className="text-4xl font-extrabold text-orange-700 drop-shadow-sm mb-3">
          🏛️ आपके प्रतिनिधि
        </h2>
        <p className="text-gray-700 text-md max-w-2xl mx-auto italic">
          भारत को जवाबदेह बनाते हैं आपके ये प्रतिनिधि — इनका कार्यकाल, वादे और जनता से जुड़ाव देखें।
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {mockRepresentatives.map((rep, index) => (
          <PartyRepresentativeCard key={index} {...rep} />
        ))}
      </div>

      <div className="text-center mt-12">
        <button className="bg-green-700 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-800 transition shadow">
          🔍 View All Representatives
        </button>
      </div>
    </section>
  );
};

export default PartyRepresentativesSection;
